<template>
  <div class="brands-slider">
    <div class="brands-track">
      <img
        v-for="(brand, index) in brands"
        :key="'first-' + index"
        class="brand-logo"
        :src="require(`@/assets/brands/${brand.src}`)"
        :alt="brand.alt"
      />
      <img
        v-for="(brand, index) in brands"
        :key="'second-' + index"
        class="brand-logo"
        :src="require(`@/assets/brands/${brand.src}`)"
        :alt="brand.alt"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "Brands",
  data() {
    return {
      brands: [
        { src: "esteelauder.png", alt: "Estee Lauder" },
        { src: "gillete.png", alt: "Gillette" },
        { src: "loreal.png", alt: "L'Oreal" },
        { src: "adidas.png", alt: "Adidas" },
        { src: "chanel.png", alt: "Chanel" },
        { src: "ck.png", alt: "Calvin Klein" },
        { src: "zara.png", alt: "Zara" },
        { src: "lv.png", alt: "Louis Vuitton" },
        { src: "mac.png", alt: "MAC" },
        { src: "Maybelline.png", alt: "Maybelline" },
        { src: "nike.png", alt: "Nike" },
        { src: "nudiejeans.png", alt: "Nudie Jeans" },
        { src: "P&G.png", alt: "P&G" },
        { src: "UNIQLO.png", alt: "Uniqlo" },
        { src: "rayban.png", alt: "Rayban" },
        { src: "H&M.png", alt: "H&M" },
        { src: "peak.png", alt: "Peak" },
        { src: "Hermes.png", alt: "Hermes" },
        { src: "ralphlauren.png", alt: "Ralph Lauren" },
        { src: "shiseido.png", alt: "Shiseido" },
        { src: "lancome.png", alt: "Lancome" },
        { src: "clinique.png", alt: "Clinique" },
      ],
    };
  },
};
</script>

<style scoped>
.brands-slider {
  width: 100%;
  overflow: hidden;
  background-color: white;
  height: 154px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
}

.brands-track {
  display: flex;
  justify-content: space-between;
  align-items: center;
  animation: scroll 40s linear infinite;
  height: 100%;
  width: max-content;
  gap: 120px;
}

.brand-logo {
  width: auto;
  height: auto;
  filter: grayscale(100%);
}

@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

@media (max-width: 1280px) {
  .brands-slider {
    height: 90px;
  }
  .brands-track {
    gap: 100px;
  }
}

@media (max-width: 1024px) {
  .brands-slider {
    height: 80px;
    padding: 10px;
  }
  .brands-track {
    gap: 79px;
  }
}
@media (max-width: 744px) {
  .brands-track {
    gap: 52px;
  }
}
@media (max-width: 431px) {
  .brands-track {
    gap: 35px;
  }
}
</style>
